'use client'

import { createContext, useContext } from 'react'

interface ModalContextValue {
  insideModal: boolean
}

export const ModalContext = createContext<ModalContextValue>({
  insideModal: false,
})

export const useModalContext = () => useContext(ModalContext)

export const ModalProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <ModalContext.Provider value={{ insideModal: true }}>
      {children}
    </ModalContext.Provider>
  )
}
